import { EMPTY, Observable, timer } from 'rxjs';
import { expand, switchMap } from 'rxjs/operators';

export function poll<T>(condition: (value: T) => boolean, delays = [1000, 4000, 8000, 16000, 32000, 64000, 92000, 128000, 256000]) {
  return (source: Observable<T>) =>
    source.pipe(
      expand((value, i) => {
        if (condition(value)) {
          return EMPTY;
        }
        if (i >= delays.length) {
          return EMPTY;
        }
        return timer(delays[i]).pipe(switchMap(() => source));
      })
    );
}
